//* 직원별 통계
import React, { useEffect, useState, useRef } from "react";
import moment from 'moment';
import StatisticsSubDateSearch from "atoms/statistics/StatisticsSubDateSearch";
import { useReactToPrint } from 'react-to-print';
import { getTodayDate, getPreviousWeekDate, getPreviousMonthDate, getPreviousYearDate } from "../../utils/Common.utils";
import { utils, writeFile } from 'xlsx';

const Staff = () => {
  const componentRef = useRef();
  const tableRef = useRef();
  const today = getTodayDate()?.slice(0,17);
  const todayDate = moment(new Date()).format("YYYYMMDD");
  const [periodOption, setPeriodOption] = useState(null);
  const [startDate, setStartDate] = useState(getTodayDate()?.slice(0,17));
  const [endDate, setEndDate] = useState('');
  const [periodValue, setPeriodValue] = useState(0);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `직원별 통계_${todayDate}`,
  });

  const subSearchAction = (getValue) => {
    setPeriodValue(getValue);

    if (getValue === 0){
      setStartDate(today);
      setEndDate(null);
    } else if(getValue === 1){
      setStartDate(getPreviousWeekDate()?.slice(0,17));
      setEndDate(today);
    } else if(getValue === 2){
      setStartDate(getPreviousMonthDate()?.slice(0,17));
      setEndDate(today);
    } else{
      setStartDate(getPreviousYearDate()?.slice(0,17));
      setEndDate(today);
    }
    setPeriodOption(getValue);
  }

  const setPeriodSearchDate = (startDate, endDate) => {
    setStartDate(startDate);
    setEndDate(endDate);
    setPeriodOption('4');
    setPeriodValue(1);
  }

  const exportFile = () => {
    const table = tableRef.current;
    const workSheet = utils.table_to_sheet(table);
    const workBook = utils.book_new();
    utils.book_append_sheet(workBook, workSheet, "SalesData");
    writeFile(workBook, `직원별 통계_${todayDate}.xlsx`);
  };
  

	return (
		<>
      <section className="section com_lnb2">
        <div className="inner">
          <article className="com_lnb2_left">
            <select className="select">
              <option>전체</option>
              <option>접수</option>
              <option>상담</option>
              <option>준비</option>
              <option>시술</option>
              <option>관리</option>
              <option>마무리</option>
            </select>
          </article>
          <article className="com_lnb2_right">
            <StatisticsSubDateSearch searchHandler={subSearchAction} setPeriodSearchDate={setPeriodSearchDate}/>
          </article>
        </div>
      </section>
      <section className="com_content">
        <div ref={componentRef}>
          <div className="com_list box">
            <article className="top_area">
              <div className="info_field">
                <p className="date">{periodValue === 0 ?  `${startDate}` : `${startDate} ~ ${endDate}`}</p>
              </div>
            </article>
            <div className="scroll with_btn_bottom">
              <table className="list" ref={tableRef}>
                <colgroup><col width="12.5%"/><col/><col width="12.5%"/><col width="12.5%"/><col width="12.5%"/><col width="12.5%"/><col width="12.5%"/><col width="12.5%"/></colgroup>
                <thead className="sticky top">
                  <tr>
                    <th colSpan="8">직원별통계</th>
                  </tr>
                  <tr>
                    <th>이름
                      <button className="btn_sort active"><i className="svg_icon icon_sort">&nbsp;</i></button>
                    </th>
                    <th>종합
                      <button className="btn_sort"><i className="svg_icon icon_sort">&nbsp;</i></button>
                    </th>
                    <th>시술명
                      <button className="btn_sort"><i className="svg_icon icon_sort">&nbsp;</i></button>
                    </th>
                    <th>여드름 케어
                      <button className="btn_sort"><i className="svg_icon icon_sort">&nbsp;</i></button>
                    </th>
                    <th>어시스트
                      <button className="btn_sort"><i className="svg_icon icon_sort">&nbsp;</i></button>
                    </th>
                    <th>에스테틱
                      <button className="btn_sort"><i className="svg_icon icon_sort">&nbsp;</i></button>
                    </th>
                    <th>총진행건수
                      <button className="btn_sort"><i className="svg_icon icon_sort">&nbsp;</i></button>
                    </th>
                    <th>상담 매출(원)
                      <button className="btn_sort"><i className="svg_icon icon_sort">&nbsp;</i></button>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>가길동</td>
                    <td>간호조무사</td>
                    <td>0</td>
                    <td>0</td>
                    <td>0</td>
                    <td>0</td>
                    <td>0</td>
                    <td><span className="txt_blue">45,000</span></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="com_btn_bottom_area">
          <button className="com_btn l blue" onClick={exportFile}><i className="svg_icon icon_down white">&nbsp;</i>다운로드</button>
          <button className="com_btn l blue line" onClick={handlePrint}><i className="svg_icon icon_print yellow">&nbsp;</i>인쇄</button>
        </div>
      </section>
		</>
	)
}

export default Staff